// @flow
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  background: transparent;
  width: 33px;
  position: relative;
  display: inline-block;
  border-radius: 50%;
  &::before {
    content: '';
    display: inline-block;
    padding-top: 100%;
  }
`
const StyledSVG = styled.svg`
  animation: loaderRotate 2s linear infinite;
  transform-origin: center center;
  height: 125%;
  width: 125%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: -3px;
  right: 0;
  margin: auto;

  @keyframes loaderRotate {
    100% {
      transform: rotate(360deg);
    }
  }
`

const StyledCircle = styled.circle`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: loaderDash 1.5s ease-in-out infinite;
  stroke-linecap: round;

  @keyframes loaderDash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
`

const LoadingCircleSmall = () => {
  return (
    <Wrapper>
      <StyledSVG viewBox="25 25 50 50">
        <StyledCircle cx="50" cy="50" r="20" fill="none" stroke="#aedd99" strokeWidth="2.5" />
      </StyledSVG>
    </Wrapper>
  )
}

export default LoadingCircleSmall



// WEBPACK FOOTER //
// ./src/components/Icons/LoadingCircleSmall.js